import { isEmpty, scrollToId, scrollIdIntoView } from ".";
import { getPath } from "../../../utils";

export const handlePhotoVerificationValidations = (
  initialState,
  scrollContainerId
) => {
  const errors = {};
  let scrolledToError = false;

  const driverPhotoId = "basic_details.driver_photo";

  const driverPhoto = getPath(initialState, driverPhotoId);

  if (
    driverPhoto?.verified === false &&
    isEmpty(driverPhoto?.rejection_reason)
  ) {
    errors[`${driverPhotoId}.rejection_reason`] =
      "Please select a reason for rejection";
    scrollIdIntoView({
      id: `${driverPhotoId}.rejection_reason`,
      containerId: scrollContainerId,
    });
    scrolledToError = true;
  }

  const impersonationId = "basic_details.impersonation";

  const impersonation = getPath(initialState, impersonationId);

  if (
    impersonation?.verified === false &&
    isEmpty(impersonation?.rejection_reason)
  ) {
    errors[`${impersonationId}.rejection_reason`] =
      "Please select at least one image for rejection";
    if (!scrolledToError) {
      scrollIdIntoView({
        id: `${impersonationId}.rejection_reason`,
        containerId: scrollContainerId,
      });
      scrolledToError = true;
    }
  }

  const deviceLinkagesId = "basic_details.device_linkages";

  const deviceLinkages = getPath(initialState, deviceLinkagesId);

  if (
    deviceLinkages?.verified === false &&
    isEmpty(deviceLinkages?.rejection_reason)
  ) {
    errors[`${deviceLinkagesId}.rejection_reason`] =
      "Please select at least one image for rejection";
    if (!scrolledToError) {
      scrollIdIntoView({
        id: `${deviceLinkagesId}.rejection_reason`,
        containerId: scrollContainerId,
      });
      scrolledToError = true;
    }
  }

  return errors;
};
